import Typography from "@mui/material/Typography";
import { Grid } from "@mui/material";
import React from "react";

import { others, colors } from "../../styles/colors";
import {
  ErrorBox,
  GridItem,
  GridLayout,
  InvalidRequestCardSx,
  InvalidRequestContentGridSx,
  InvalidRequestErrorBoxSx,
  InvalidRequestLayoutSx,
  InvalidRequestSubtitleSx,
  InvalidRequestTitleSx,
} from "../styles/styles";

const Fragment = React.Fragment;

const ForbiddenPage = () => {
  return (
    <Fragment>
      <GridLayout container sx={InvalidRequestLayoutSx}>
        <Grid size={{ xs: 12 }} sx={InvalidRequestContentGridSx}>
          <GridItem sx={InvalidRequestCardSx}>
            <ErrorBox sx={InvalidRequestErrorBoxSx}>
              <Typography
                variant="h1"
                color={others.otherColors[10]}
                fontWeight="fontWeightBold"
                fontSize={{ xs: "1.8rem", md: "2.3rem" }}
                lineHeight={1.15}
                sx={InvalidRequestTitleSx}
              >
                403 Access Forbidden!
              </Typography>
              <Typography
                variant="h3"
                color={colors.primary.main}
                fontWeight="500"
                pt={"0.7rem"}
                pb={"0.4rem"}
                sx={InvalidRequestSubtitleSx}
              >
                You do not have permission to access this page.
              </Typography>
            </ErrorBox>
          </GridItem>
        </Grid>
      </GridLayout>
    </Fragment>
  );
};

export default ForbiddenPage;
